import React from "react";
import {
  Box,
  // Button,
  Typography,
  Paper,
  TextField,
  Stack,
} from "@mui/material";
import { useState, useEffect } from "react";
import { fetchScopeData } from "../../../api/fetchScopeData";
import { updateScopeData } from "../../../utils/updateScopeData"; // Updated import
import UpdateIcon from "@mui/icons-material/Update";
import LogButtonScope from "./ScopeComponent/LogButtonScope"; // Import LogButtonScope
import UpdateIconDesign from "../../common/UpdateIconQMS";
//       console.log("✅ Policy updated successfully!");
export default function QualityScope({ onShowLogs }) {
  const [policyData, setPolicyData] = useState([]); // Store fetched data
  const [scopeText, setPolicyText] = useState(""); // Manage the field value
  const [recordId, setRecordId] = useState(""); // Store the record ID

  useEffect(() => {
    const initializeApp = async () => {
      try {
        if (window.ZOHO && ZOHO.embeddedApp) {
          await ZOHO.embeddedApp.init();
          console.log("✅ ZOHO embedded app initialized in QualityScope");
        } else {
          console.warn("⚠️ ZOHO embeddedApp not available in QualityScope");
          return;
        }

        const data = await fetchScopeData(); // Correct function call
        if (data.length > 0) {
          setPolicyData(data); // Store the fetched data
          setPolicyText(
            data[0].Objective_Description || "No description available"
          ); // Use Objective_Description
          setRecordId(data[0].ID); // Store the record ID
        } else {
          console.warn("⚠️ No policy data found");
        }
      } catch (err) {
        console.error("❌ Error initializing QualityScope:", err);
      }
    };

    initializeApp();
  }, []);

  const handleTextChange = (e) => {
    setPolicyText(e.target.value); // Update state on user input
  };

  const handleUpdate = async () => {
    if (!recordId) {
      alert("Record ID is missing. Cannot update the policy.");
      return;
    }

    const updateData = {
      Objective_Description: scopeText, // Update the policy text field
    };

    const success = await updateScopeData(recordId, updateData); // Updated function call
    if (success) {
      console.log("✅ Scope updated successfully!");
    }
  };

  const ActionButtons = () => {
    return (
      <Stack direction="row" spacing={1}>
        <UpdateIconDesign
          sx={{
            minWidth: 80,
            height: 36,
            px: 2,
            py: 0.5,
          }}
          onClick={handleUpdate} // Connect the Edit button to the update logic
          icon={<UpdateIcon />}
        />
        <LogButtonScope /> {/* Use LogButtonScope here */}
      </Stack>
    );
  };

  return (
    <Box sx={{ mt: 0 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <Typography variant="h6" fontWeight="bold" sx={{ color: "#4F46E5" }}>
          Quality Scope
        </Typography>
        <ActionButtons onShowLogs={onShowLogs} />
      </Box>

      <Box mt={2}>
        <TextField
          id="quality_Scope_textfield" // Updated ID
          fullWidth
          multiline
          rows={10}
          mb={2}
          variant="outlined"
          value={scopeText}
          onChange={handleTextChange} // Handle user input
        />
      </Box>

      {/* Display additional policy data */}
      {policyData.length === 0 && (
        <Typography mt={2}>No Scope data available.</Typography>
      )}
    </Box>
  );
}
